import HomeIcon from "@mui/icons-material/Home";
import Refresh from "@mui/icons-material/Refresh";
import {
  Alert,
  Box,
  Dialog,
  IconButton,
  LinearProgress,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useAppSelector } from "app/hooks";
import { Button, PageHeader, Spacer } from "common";
import { ParamsContext } from "common/components/Form/ParamsContext";
import BookingForm from "features/bookings/BookingForm";
import { selectProfile } from "features/profile/profileSlice";
import StreetSalesFilter from "features/street-sales/StreetSalesFilter";
import useStreetSalesList from "features/street-sales/useStreetSalesList";
import useHeaderHeight from "helpers/useHeaderHeight";
import moment from "moment";
import { useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import PartnerStreetSalesList from "./PartnerStreetSalesList";

export default function PartnerHome() {
  const {
    streetSalesData,
    loading,
    load,
    handleFilter,
    setRange,
    range,
    isEmpty,
    setSettings,
  } = useStreetSalesList();
  const profile = useAppSelector(selectProfile);
  console.log({ profile });
  const headerHeight = useHeaderHeight();
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));

  const [bookingDialog, setBookingDialog] = useState<{
    open: boolean;
    booking?: any;
    onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void;
  }>({ open: false });

  const handleBookingClick = (booking: any) => {
    console.log("Booking click data:", booking); // Debug log
    setBookingDialog({
      open: true,
      booking,
      onClose: () => setBookingDialog({ open: false }),
    });
  };

  // ParamsContext value similar to EventCalendarModals
  const paramsContextValue = useMemo(
    () => ({
      event_id: bookingDialog.booking?.event_id,
      program_id: bookingDialog.booking?.event?.program_id,
      schedule_id: bookingDialog.booking?.event?.schedule_id,
      partner_id: profile.partner_id,
    }),
    [bookingDialog.booking],
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box
        sx={{
          px: smDown ? 2 : 0,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <PageHeader avatar={<HomeIcon />} title="Foglalási felület">
          <IconButton onClick={() => load()}>
            <Refresh />
          </IconButton>
        </PageHeader>
        <StreetSalesFilter
          setRange={setRange}
          range={range}
          showPrograms={false}
        />
        <Spacer h={1} />
        <PartnerStreetSalesList
          streetSalesData={streetSalesData}
          onItemClick={handleBookingClick}
        />
        {loading && (
          <LinearProgress
            sx={{ position: "fixed", left: 0, top: headerHeight, right: 0 }}
          />
        )}
        {isEmpty && (
          <Alert
            severity="info"
            action={
              <Button
                variant="text"
                title="Reset"
                size="small"
                onClick={() => {
                  setRange({
                    start: moment().startOf("day"),
                    end: moment().endOf("day"),
                  });
                  setSettings({ programIds: undefined, boatIds: undefined });
                }}
              />
            }
          >
            A kiválasztott dátumon szolgáltatásunk nem elérhető. Kérem tekintse
            meg más napokon kínált lehetőségeinket.
          </Alert>
        )}
      </Box>

      <ParamsContext.Provider value={paramsContextValue}>
        <Dialog
          keepMounted
          open={bookingDialog.open}
          onClose={bookingDialog.onClose}
          maxWidth={
            bookingDialog.booking?.event?.program?.has_options ||
            bookingDialog.booking?.planned_event?.program?.has_options
              ? "lg"
              : "sm"
          }
          fullWidth
          fullScreen={mdDown}
        >
          {bookingDialog?.open && (
            <BookingForm
              isPartnerView
              id={
                bookingDialog.booking?.id
                  ? String(bookingDialog.booking?.id)
                  : "create"
              }
              defaultValues={{
                ...bookingDialog.booking,
                partner_id: profile.partner_id,
                customer_requests_invoice: false, // !profile.partner?.monthly_billing,
              }}
              onClose={() =>
                bookingDialog.onClose &&
                bookingDialog.onClose({}, "backdropClick")
              }
              afterSave={(booking: any) => {
                /*bookingDialog.onClose &&
                  bookingDialog.onClose({}, "backdropClick");*/
                setBookingDialog({ ...bookingDialog, booking });
                load(); // Refresh data after save
              }}
            />
          )}
        </Dialog>
      </ParamsContext.Provider>

      <Outlet />
    </Box>
  );
}
